import React from 'react';

import Spinner from './Spinner';

export default function Loading({text}) {

    const containerStyle = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
        margin: 10,
        padding: 10,
    };

    const loadingTextStyle = {
        fontSize: 13,
    }

    return <div style={containerStyle} aria-label="Loading">
        <Spinner/>
        <small style={loadingTextStyle}>{text}</small>
    </div>;
}